import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { activateEditMode } from 'src/app/root-store/jobseeker-store/jobseeker-subscription/actions';

@Component({
    selector: 'app-jobseeker-unsubscriber-complete',
    templateUrl: './jobseeker-unsubscribe-complete.component.html',
    styleUrls: ['./jobseeker-unsubscribe-complete.component.scss'],
    standalone: false
})
export class JobseekerUnsubscribeCompleteComponent implements OnInit {

  constructor(private store: Store, private router: Router) { }

  onActivateEditMode(){
    this.store.dispatch(activateEditMode());
    this.router.navigate(['/jobseeker/subscription/edit']);
  }

  ngOnInit(): void {
  }

}
